import React, { useEffect } from "react";
import { Modal, Form, Row, Col, Card, Mentions, Avatar, Alert } from "antd";
import { CommentaireService } from "../../services/CommentaireService";
import { catchError } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import CustomFormItem from "../utils/form/CustomFormItem";
import UserService from "../../services/UserService";

const CommentaireEditForm = ({ visible, uid, onUpdate, onCancel }) => {
  const [form] = Form.useForm();
  const [editing, setEditing] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});

  const [users, setUsers] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!visible) {
      return
    }
    setLoading(true);
    UserService.getInstance()
      .all()
      .then((response) => {
        setUsers(response.data);
      }).catch(catchError)
      .finally(() => {
        setLoading(false);
      });
  }, [visible, uid]);

  useEffect(() => {
    if (uid) {
      setEditing(true);
      CommentaireService.getInstance()
        .find(uid)
        .then((response) => {
          form.setFieldsValue(response.data);
        })
        .catch((error) => {
          catchError(error);
        })
        .finally(() => {
          setEditing(false);
        });
    }
  }, [uid, form]);

  const handleSave = () => {
    setEditing(true);
    form
      .validateFields()
      .then((values) => {
        CommentaireService.getInstance()
          .update(uid, values)
          .then((response) => {
            Toast.success(response.message);
            onUpdate(response.data);
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setEditing(false);
          });
      })
      .catch(() => {
        setEditing(false);
      });
  };

  return (
    <Modal
      width={"50%"}
      open={visible}
      onCancel={onCancel}
      okText="Enregistrer"
      onOk={handleSave}
      title="Modifier commentaire"
      forceRender
    >
      <Card loading={editing} style={{ marginBottom: 20 }}>
        <Form
          layout="vertical"
          form={form}
          name="editCommentaireForm"
          initialValues={{
            enabled: 1,
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={24}>
              <Alert
                message="Astuce : Vous pouvez mentionner vos collaborateurs en utilisant @, ils seront notifiés."
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
              />
              <CustomFormItem
                label="Commentaire"
                name="comment"
                rules={[{ required: true, message: "Veuillez saisir le commentaire!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Mentions rows={10} placeholder="Saisir ici..." allowClear
                  loading={loading} options={users.map(user => ({
                    value: user.email, label: (
                      <>
                        <Avatar src={user.avatar} size="small" style={{ marginRight: 5 }} /> {user.name}
                      </>
                    )
                  }))}
                />
              </CustomFormItem>
            </Col>
          </Row>

        </Form>
      </Card>
    </Modal>
  );
};

export default CommentaireEditForm;

CommentaireEditForm.propTypes = {
  visible: PropTypes.bool,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func,
  uid: PropTypes.string.isRequired
};
